import { motion } from "framer-motion";
import { useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { CheckCircle } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { ThemeProvider } from "@/providers/ThemeProvider";

import { useDocumentTitle } from "@/hooks/useDocumentTitle";

export default function CheckoutSuccess() {
  const navigate = useNavigate();
  const { accessToken } = useParams();
  const { t } = useTranslation("preventiveRequest");

  useDocumentTitle(t("success"));

  return (
    <ThemeProvider>
      <div className="min-h-screen bg-background flex items-center justify-center p-4">
        <motion.div
          initial={{ opacity: 0, scale: 0.9 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.3 }}
          className="w-full max-w-md"
        >
          <Card>
            <CardContent className="p-8 flex flex-col items-center text-center gap-6">
              <motion.div
                initial={{ scale: 0 }}
                animate={{ scale: 1 }}
                transition={{ delay: 0.15, type: "spring", stiffness: 200 }}
              >
                <CheckCircle className="h-16 w-16 text-green-500" />
              </motion.div>

              <div className="space-y-2">
                <h1 className="text-2xl font-bold">{t("success")}</h1>
                <p className="text-muted-foreground">{t("successMessage")}</p>
              </div>
            </CardContent>
          </Card>
        </motion.div>
      </div>
    </ThemeProvider>
  );
}
